module.exports = __webpack_public_path__ + "static/media/fund_details_cover.f08a87c5.png";